"use client";
import { Suspense } from "react";
import "../terms/Terms.scss";

export default function DMCAPage() {
  return (
    <Suspense>
      <div className="dmca-main-container font-sans">
        <h1>DMCA</h1>
        <div className="text-container">
          <h4>Digital Millennium Copyright Act Policy</h4>

          <p>
            We respect the intellectual property rights of others just as we
            expect others to respect our rights. Pursuant to Digital Millennium
            Copyright Act, Title 17, United States Code, Section 512(c), a
            copyright owner or their agent may submit a takedown notice to us
            via our DMCA Agent listed below. We will respond to notices of
            alleged copyright infringement that comply with the Digital
            Millennium Copyright Act and/or any other applicable intellectual
            property legislation or laws.
          </p>

          <p>
            By utilizing the Website you agree that you have consulted with an
            attorney of your own choosing and at your own expense in order to
            fully understand all of your legal rights and obligations as a
            result of utilizing the Website and these Copyright Infringement
            Notification Instructions.
          </p>

          <p>
            Pursuant to 17 U.S.C. Section 512(k)(1) of the DMCA, this Website is
            a "Service Provider" and is entitled to certain protections commonly
            referred to as the "Safe Harbor" provisions.
          </p>
          <br />
          <h4>
            Filing a DMCA Notice to Remove Copyrighted Content - Claim of
            Infringement
          </h4>

          <p>
            If you believe that someone has posted material that infringes your
            copyright, a notification of a claimed copyright infringement must
            be provided via email or regular mail to us and must include the
            following information (if you do not understand the language please
            seek independent legal advice):
          </p>

          <p>
            A physical or electronic signature of a person authorized to act on
            behalf of the owner of an exclusive right that is allegedly
            infringed;
          </p>
          <p>
            Identification of the copyrighted work claimed to have been
            infringed, or, if multiple copyrighted works at a single online site
            are covered by a single notification, a representative list of such
            works at that site;
          </p>
          <p>
            Identification of the material that is claimed to be infringing or
            to be the subject of infringing activity and that is to be removed
            or access to which is to be disabled, and information reasonably
            sufficient to permit the service provider to locate the material;
          </p>
          <p>
            Information reasonably sufficient to permit the service provider to
            contact the complaining party, such as an address, telephone number,
            and, if available, an electronic mail address at which the
            complaining party may be contacted;
          </p>
          <p>
            A statement that the complaining party has a good faith belief that
            use of the material in the manner complained of is not authorized by
            the copyright owner, its agent, or the law;
          </p>
          <p>
            A statement that the information in the notification is accurate,
            and under penalty of perjury, that the complaining party is
            authorized to act on behalf of the owner of an exclusive right that
            is allegedly infringed;
          </p>
          <p>
            Title 17 USC Section 512(f) provides civil damage penalties,
            including costs and attorney fees, against any person who knowingly
            and materially misrepresents certain information in a notification
            of infringement under 17 USC Section 512(c)(3).
          </p>

          <p>
            Please note that we may share the identity and information in any
            copyright infringement claim we receive with the alleged infringer.
            In submitting a claim, you understand accept and agree that your
            identity and claim may be communicated to the alleged infringer.
            Send all takedown notices to our DMCA Agent listed below.
          </p>
          <br />
          <h4>
            Please send by email for prompt attention: dmca@celebstory.com
          </h4>

          <p>
            We take copyright infringement very seriously. Pursuant to the
            repeat infringer policy requirements of the Digital Millennium
            Copyright Act, we maintain a list of DMCA notices from copyright
            holders and make a good faith effort to identify any repeat
            infringers. Those that violate our internal repeat infringer policy
            will have their accounts terminated.
          </p>

          <p>
            These Copyright Infringement Notification Instructions may be and
            shall be modified from time to time without notice. You are solely
            responsible for regularly reviewing these Copyright Notification
            Instructions.
          </p>
        </div>
      </div>
    </Suspense>
  );
}
